export const STRUCTURE_MODELING_TARGET_ELEMENETS_SUCCESS = 'STRUCTURE_MODELING_TARGET_ELEMENETS_SUCCESS';

import apiClient from 'ps-components/lib/apiClient';

export function getTargetElements() {
  return async dispatch => {
    //api/report-writer/element-tree/
    const targetElementResults = await apiClient.apiPost('/api/report-writer/element-tree/lookup', {
      category_code: 'structure_elements_selection',
      elementsTreeFlattened: true,
      fieldTypeCodes: ['monetary']
    });

    if (targetElementResults.status === 200) {
      dispatch({ type: STRUCTURE_MODELING_TARGET_ELEMENETS_SUCCESS, targetElements: targetElementResults.data });
    }
  };
}
